import React from 'react';
import PropTypes from 'prop-types';

import {Stack} from 'views/components';
import {translate} from 'views/module';

import {DraftTextField} from '../AgentJobDraftFields';
import {formatPayloadDetail, getRecipientListDetail} from '../../agentJobTypeUtils';

const SmsAgentJobDraft = (props) => {
  const {
    draftPayload,
    updatePayloadField,
  } = props;

  return (
    <Stack sx={{gap: 1.25}}>
      <DraftTextField
        label={translate('case.Detail.AgentJobs.Fields.To')}
        onChange={updatePayloadField('resourceRn')}
        value={draftPayload.resourceRn}
      />
      <DraftTextField
        label={translate('case.Detail.AgentJobs.Fields.Sender')}
        onChange={updatePayloadField('sender')}
        value={draftPayload.sender}
      />
      <DraftTextField
        label={translate('case.Detail.AgentJobs.Fields.Message')}
        multiline
        onChange={updatePayloadField('message')}
        value={draftPayload.message}
      />
    </Stack>
  );
};

SmsAgentJobDraft.propTypes = {
  draftPayload: PropTypes.object.isRequired,
  updatePayloadField: PropTypes.func.isRequired,
};

const buildPayload = ({draftPayload}) => {
  const nextPayload = {...draftPayload};

  if (!nextPayload.sender) {
    delete nextPayload.sender;
  }

  return nextPayload;
};

const getDraftBody = (job) => job.actionPayload?.message || '';

const getListDetail = (job, participantDetails) => {
  const payload = job.actionPayload || {};

  return [
    getRecipientListDetail(participantDetails, payload.resourceRn || job.resourceRn),
    formatPayloadDetail(payload.message),
  ].filter(Boolean).join(' - ');
};

export default {
  Draft: React.memo(SmsAgentJobDraft),
  actionType: 'SMS',
  buildPayload,
  getDraftBody,
  getListDetail,
  label: translate('case.Detail.AgentJobs.ActionLabels.Sms'),
};
